export default "__VITE_ASSET__Bd56os3R__"